import { render, staticRenderFns } from "./my_coll_course_plan.vue?vue&type=template&id=25030400&scoped=true"
import script from "./my_coll_course_plan.vue?vue&type=script&lang=js"
export * from "./my_coll_course_plan.vue?vue&type=script&lang=js"
import style0 from "./my_coll_course_plan.vue?vue&type=style&index=0&id=25030400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25030400",
  null
  
)

export default component.exports